var map = {
	"./": "c270",
	"./basic": "9437",
	"./basic.js": "9437",
	"./channel": "94b4",
	"./channel.js": "94b4",
	"./comment": "9cbf",
	"./comment.js": "9cbf",
	"./group": "cfbb",
	"./group.js": "cfbb",
	"./index": "c270",
	"./index.js": "c270",
	"./label": "5daa",
	"./label.js": "5daa",
	"./material": "b533",
	"./material.js": "b533",
	"./media": "27e4",
	"./media.js": "27e4",
	"./message": "5252",
	"./message.js": "5252",
	"./polyline": "e43c",
	"./polyline.js": "e43c",
	"./region": "1649",
	"./region.js": "1649",
	"./regionAdmin": "9344",
	"./regionAdmin.js": "9344",
	"./setting": "f6fa",
	"./setting.js": "f6fa",
	"./shop": "ed68",
	"./shop.js": "ed68",
	"./spot": "ce31",
	"./spot.js": "ce31",
	"./storage": "c04c",
	"./storage.js": "c04c",
	"./user": "43b5",
	"./user.js": "43b5",
	"./userAdmin": "05d0",
	"./userAdmin.js": "05d0",
	"./vr": "a2c3",
	"./vr.js": "a2c3",
	"./works": "7acd",
	"./works.js": "7acd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f3be";